import { styled } from "styled-components";

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 40px;
`;
